import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';

import { Metamodel } from 'app/model/base/model';
import { TabularTypeDatasetAdapter, tabularTypeDatasetAdapts } from './tabular-type.dataset.adapter';
import { RelationalTableDataset } from 'app/model/dataset/relational-table.dataset';
import { adfModelTypeMap } from 'app/registries/consts/adf-model-type-map-const';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(RelationalTableDataset),
    asynchronous: true,
    adapts: tabularTypeDatasetAdapts
})
export class RelationalTableDatasetAdapter extends TabularTypeDatasetAdapter<RelationalTableDataset, Model.DatasetResource> {
    protected async _toResource(dataset: RelationalTableDataset): Promise<Model.DatasetResource> {
        const relationalResource: Model.DatasetResource = await this._toResourceInternal(dataset, Metamodel.modelFor(RelationalTableDataset).name);
        // relational dataset supports ['AmazonRedshift', 'Db2', 'MySql', 'Odbc', 'PostgreSql', 'SapBw', 'SapHana', 'Sybase', adfModelTypeMap.teradata.linkedServiceType]
        // SAP BW and SAP HANA doesn't support table name, need remove tableName from the resource
        if (dataset && dataset.linkedService && relationalResource && relationalResource.properties && relationalResource.properties.typeProperties) {
            if ((Metamodel.modelOf(dataset.linkedService).name === adfModelTypeMap.sapHana.linkedServiceType) ||
                Metamodel.modelOf(dataset.linkedService).name === adfModelTypeMap.sapBw.linkedServiceType) {
                delete relationalResource.properties.typeProperties['tableName'];
            }
        }
        return relationalResource;
    }

    protected async _toModel(modelDatasetResource: Model.DatasetResource, dataset?: RelationalTableDataset): Promise<RelationalTableDataset> {
        return await this._toModelInternal(modelDatasetResource, dataset, RelationalTableDataset.MODEL);
    }
}
